import { deviceType, batteryLevel, voltageLevel } from "../constant";

export const batteryOK = (car, siteSettingsData) => {
  if (!car.UseVoltage) {
    return siteSettingsData?.GuardianCapable && !car.IsCharging && (car.BatteryLevel > batteryLevel.warning) && (car.BatteryLevel <= 100);
  }

  else if (car.UseVoltage && car?.DevType === deviceType.FT2) {
    return car?.BatteryVoltage > voltageLevel.warning;
  }
};